import { render, staticRenderFns } from "./UserFieldsTable.vue?vue&type=template&id=8991f284&scoped=true&"
import script from "./UserFieldsTable.vue?vue&type=script&lang=js&"
export * from "./UserFieldsTable.vue?vue&type=script&lang=js&"
import style0 from "./UserFieldsTable.vue?vue&type=style&index=0&id=8991f284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8991f284",
  null
  
)

export default component.exports